import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

import { LeadStaticHeadlineMetricData } from ".";
import { useIsMobile } from "../../hooks";
import { LeadHeadLineMetricsTranslatedContent } from "../types";

type LeadsInfoDashboardSkeletonProps = {
  translatedContent?: LeadHeadLineMetricsTranslatedContent;
};

export const LeadsInfoDashboardSkeleton = ({
  translatedContent,
}: LeadsInfoDashboardSkeletonProps) => {
  const isMobile = useIsMobile();

  const staticHeadlineMetricData: LeadStaticHeadlineMetricData[] = [
    {
      key: "profileCreated",
      title: translatedContent?.profileCreated,
    },
    {
      key: "onboarding",
      title: translatedContent?.onboarding,
      tooltip: translatedContent?.onboardingTooltip,
    },
    {
      key: "approved",
      title: translatedContent?.approved,
    },
  ];

  return (
    <div
      className={`flex gap-6 ${isMobile ? "flex-col" : "flex-row"}`}
      data-testid="leads-info-dashboard-skeleton"
    >
      {staticHeadlineMetricData.map((stat, index) => (
        <div
          key={index}
          className="flex w-full flex-col justify-between rounded-xl bg-surface-base-brand px-6 py-4 md:px-8 md:py-6"
        >
          <div className="mb-4">
            <span className="text-sm font-semibold text-text-base-secondary md:text-base">
              {stat.title}
            </span>
          </div>
          <div className="mb-2">
            <SkeletonLoader variant="rectangular" width={12} height={10} />
          </div>
          <div className="flex items-center">
            <div>
              <SkeletonLoader variant="rectangular" width={30} height={6} />
            </div>
            <div>
              <SkeletonLoader variant="rectangular" width={32} height={6} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
